import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import coverDesktop from "@assets/images/about_omat_cover.png";
import coverMobile from "@assets/images/about_omat_cover_for_mobile.svg";
import coverProgram from "@assets/images/cover_program.svg";
import iuLogo from "@assets/images/iu.png";
import largeCoverDesktop from "@assets/images/omat-large_cover.png";
import largeCoverMobile from "@assets/images/omat_large_cover_for_mobile.png";
import saaLogo from "@assets/images/saa.png";
import { config } from "@core/config/config";
import { useServices } from "@core/servicesContext";
import { useMyApplication } from "@domain/application/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { ImageVersions } from "@domain/media/dtos";
import { useIsMobile } from "@utils/hooks";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { Primary } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { row } from "@ui/components/layout";
import { LinkExternal } from "@ui/components/linkExternal";
import { Page } from "@ui/components/page";
import { fromLeft } from "@ui/styles/keyframes";
import { gap, mobile } from "@ui/styles/utils";
import { ApplyButton } from "./applyButton";
import { ParticipateButton, ViewBrochureButton } from "./brochureButton";
import { Bachelor } from "@ui/pages/application/applicationEditorPage/landingPage/category/bachelor";
import { Master } from "@ui/pages/application/applicationEditorPage/landingPage/category/master";
import { MBA } from "@ui/pages/application/applicationEditorPage/landingPage/category/mba";

const tabs = ["Bachelor", "Master", "MBA"] as const;
const cover_desktop = coverDesktop;
const cover_mobile = coverMobile;

const large_cover_desktop = largeCoverDesktop;
const large_cover_mobile = largeCoverMobile;

const omat_url = "https://onemillionafricantalents.com";
const saa_url = "https://www.study-access-alliance.org";
const iu_url = "https://iu.org/";
interface ApplicationLandingPageProps extends React.HTMLAttributes<HTMLDivElement> {
	applicationId?: string;
}

export const ApplicationLandingPage: React.FC<ApplicationLandingPageProps> = ({ applicationId, ...htmlProps }) => {
	const isMobile = useIsMobile();
	const currentProfile = useCurrentProfile();
	const { result: application } = useMyApplication(currentProfile?.id);

	const [tabIndex, setTabIndex] = useState<number | null>(isMobile ? null : 0);
	const currentTab = tabIndex !== null ? tabs[tabIndex] : undefined;
	const [isVisible, setIsVisible] = useState(false);
	const { trackingService } = useServices();
	//const [height, setHeight] = useState(0);

	useEffect(() => {
		trackingService.track("omat_page_view");
		window.addEventListener("scroll", listenToScroll);
		return () => window.removeEventListener("scroll", listenToScroll);
	}, []);

	const listenToScroll = (): void => {
		const heightToHideFrom = 200;
		const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
		//setHeight(winScroll);

		if (winScroll > heightToHideFrom) {
			if (!isVisible) {
				setIsVisible(true);
			}
		} else {
			setIsVisible(false);
		}
	};
	const trackPartipateButton = (): void => {
		trackingService.track("view_how_to get involved");
	};
	const trackViewProgramButton = (): void => {
		trackingService.track("View_progam_details_omat");
	};
	return (
		<GlobalContent {...htmlProps}>
			<>
				<ContainerLP>
					<OmatPresentation>
						<OneMillionText>
							<b>{I18n.t("program.page.title")}</b>
						</OneMillionText>
						<AfricanTalentText>
							<b>{I18n.t("program.page.sub_title")}</b>
						</AfricanTalentText>
						<RevelYourTalentText>{I18n.t("program.page.baseline.title")}</RevelYourTalentText>
					</OmatPresentation>
					<StyledBlocCover>
						<StyledBackgroundImageLargeCover
							image={isMobile ? large_cover_mobile : large_cover_desktop}
							defaultUrl={isMobile ? large_cover_mobile : large_cover_desktop}
							size={ImageVersions.MEDIUM}
							isBackLinearGradient
						/>
					</StyledBlocCover>
					<TalentVideoStoryText>{I18n.t("program.page.challenge.title")}</TalentVideoStoryText>
					<StyledContainerDesc>
						<DescriptionSecttionP1>{I18n.t("program.page.description.p1")}</DescriptionSecttionP1>
						<DescriptionSectionP2>{I18n.t("program.page.description.p2")}</DescriptionSectionP2>
					</StyledContainerDesc>
					<ButtonContainer>
						<LinkExternal to={!config.features.program ? "" : omat_url}>
							<ParticipateButton onClick={config.features.program ? trackPartipateButton : undefined}>
								{I18n.t("program.page.button.howto.label")}
							</ParticipateButton>
						</LinkExternal>

						{!isMobile && <ApplyButton application={application} isBig={false} />}
					</ButtonContainer>
					<StyledCoverAboutOmat>
						<StyledBackgroundImageCoverAboutOmat
							image={isMobile ? cover_mobile : cover_desktop}
							defaultUrl={isMobile ? cover_mobile : cover_desktop}
							size={ImageVersions.MEDIUM}
							isBackLinearGradient
						/>
						<Infos>
							<StyledLabel>
								<b>{I18n.t("program.page.about.title")}</b>
							</StyledLabel>
							<StyledLabel>
								<b>{I18n.t("program.page.full_title")}</b>
							</StyledLabel>
						</Infos>
					</StyledCoverAboutOmat>
					<StyledBlocProgramDesc>
						<StyledProgramDesc>{I18n.t("program.page.about.description.p1")}</StyledProgramDesc>
						<StyledProgramDesc>{I18n.t("program.page.about.description.p2")}</StyledProgramDesc>
						<StyledProgramDesc>{I18n.t("program.page.about.description.p3")}</StyledProgramDesc>
					</StyledBlocProgramDesc>
					{!isMobile ? (
						<StyledBlocCounter>
							<StyledCardCounterBourse>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.scholarships-count.label")}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.scholarships.label")}</StyledLabelText>
							</StyledCardCounterBourse>
							<StyledCardNumberOfCountry>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.countries-count.label")}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.countries.label")}</StyledLabelText>
							</StyledCardNumberOfCountry>

							<StyledCardNumberOfCursus>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.cursus-count.label", { caracter: "+" })}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.cursus.label")}</StyledLabelText>
							</StyledCardNumberOfCursus>

							<StyledCardNumberOfOnlineCourse>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.courses-count.label", { caracter: "%" })}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.courses.label")} </StyledLabelText>
							</StyledCardNumberOfOnlineCourse>
						</StyledBlocCounter>
					) : (
						<StyledBlocCounterInMobile>
							<StyledCardCounterBourseIsMobile>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.scholarships-count.label")}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.scholarships.label")}</StyledLabelText>
							</StyledCardCounterBourseIsMobile>
							<StyledCardNumberOfCountryIsMobile>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.countries-count.label")}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.countries.label")}</StyledLabelText>
							</StyledCardNumberOfCountryIsMobile>
							<StyledCardNumberOfCursusIsMobile>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.cursus-count.label", { caracter: "+" })}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.cursus.label")}</StyledLabelText>
							</StyledCardNumberOfCursusIsMobile>
							<StyledCardNumberOfOnlineCourseIsMobile>
								<StyledNumberCounter>
									<b>{I18n.t("program.insight.courses-count.label", { caracter: "%" })}</b>
								</StyledNumberCounter>
								<StyledLabelText>{I18n.t("program.insight.courses.label")}</StyledLabelText>
							</StyledCardNumberOfOnlineCourseIsMobile>
						</StyledBlocCounterInMobile>
					)}

					<BlocApply>
						{!isMobile && (
							<LeftBloc>
								<ContentCover>
									<StyledBackgroundImageCover
										image={coverProgram}
										defaultUrl={coverProgram}
										size={ImageVersions.MEDIUM}
										isBackLinearGradient
									/>
									<InfosBachelor>
										<BachelorLabel>{I18n.t("program.page.tablist.all_program.label")}</BachelorLabel>
										<ProgramUILabel>{I18n.t("program.page.tablist.program.label")}</ProgramUILabel>
									</InfosBachelor>
								</ContentCover>

								<ViewBrochureBloc>
									<LinkExternal to={!config.features.program ? "" : I18n.t("program.page.button.howto.to")}>
										<ViewBrochureButton onClick={config.features.program ? trackViewProgramButton : undefined}>
											{I18n.t("program.page.button.viewall.label")}
										</ViewBrochureButton>
									</LinkExternal>
								</ViewBrochureBloc>
							</LeftBloc>
						)}
						<RightBloc>
							<ProgramText>
								<b>{I18n.t("program.page.tablist.title")}</b>
							</ProgramText>
							<StyledTabBar>
								<StyledTabBarLabel>
									{tabs.map((tab, index) => (
										<TabView key={tab} selected={tabIndex === index} onClick={() => setTabIndex(index)}>
											<Label selected={tabIndex === index}>
												<b>{tab}</b>
											</Label>
										</TabView>
									))}
								</StyledTabBarLabel>
							</StyledTabBar>
							{currentTab === "Bachelor" ? (
								<>
									<Bachelor />
								</>
							) : currentTab === "Master" ? (
								<>
									<Master />
								</>
							) : currentTab === "MBA" ? (
								<MBA />
							) : null}
						</RightBloc>
						{isMobile && (
							<LinkExternal to={!config.features.program ? "" : I18n.t("program.page.button.howto.to")}>
								<StyledButtonViewProgram>
									<ViewBrochureButton>{I18n.t("program.page.button.viewall.label")}</ViewBrochureButton>
								</StyledButtonViewProgram>
							</LinkExternal>
						)}
					</BlocApply>
					{!isMobile && (
						<ApplyIconBloc>
							<ApplyButton application={application} isBig={true} />
						</ApplyIconBloc>
					)}
				</ContainerLP>
				<InfoPartenaire>
					<OneLineAccessCourseText>
						<b>{I18n.t("program.page.partner.title")}</b>
					</OneLineAccessCourseText>
					<ContainerPartener>
						<SAA>
							<LinkExternal to={!config.features.program ? "" : saa_url}>
								<SaaLogoContainer>
									<img src={saaLogo} />
								</SaaLogoContainer>
							</LinkExternal>
							<SaaDesc>{I18n.t("program.page.partner-saa.description.p1")}</SaaDesc>
							<SaaDesc marginTop={20}>{I18n.t("program.page.partner-saa.description.p2")}</SaaDesc>
						</SAA>
						{!isMobile && <Divider />}
						<IU>
							<LinkExternal to={!config.features.program ? "" : iu_url}>
								<IuLogoContainer>
									<img src={iuLogo} />
								</IuLogoContainer>
							</LinkExternal>
							<IuDescP1>{I18n.t("program.page.partner-iu.description.p1")}</IuDescP1>
							<IuDescP2>{I18n.t("program.page.partner-iu.description.p2")}</IuDescP2>
						</IU>
					</ContainerPartener>
				</InfoPartenaire>
				{isMobile && isVisible && (
					<ApplyIconBloc>
						<ApplyButton application={application} isBig={true} />
					</ApplyIconBloc>
				)}
			</>
		</GlobalContent>
	);
};

const GlobalContent = styled(Page)`
	display: flex;
	flex-direction: column;
	margin-bottom: 40px;
`;

const ContainerLP = styled.div`
	display: flex;
	flex-direction: column;
	background-color: white;
	border-radius: 13px;
`;

const OneMillionText = styled.div`
	display: flex;
	font-size: 28px;
	line-height: 111.5%;
	@media ${mobile} {
		font-size: 20px;
	}
`;
const AfricanTalentText = styled.div`
	display: flex;
	font-weight: 800;
	font-size: 28px;
	line-height: 111.5%;
	@media ${mobile} {
		font-size: 20px;
	}
`;

const RevelYourTalentText = styled.div`
	display: flex;
	font-weight: 300;
	font-size: 20px;
	margin-top: 4px;
	@media ${mobile} {
		font-size: 15px;
		text-align: center;
		margin-left: 20px;
		margin-right: 20px;
		margin-top: 12px;
	}
`;

const OmatPresentation = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 47px;
	margin-left: 47px;
	margin-right: 47px;
	@media ${mobile} {
		margin-top: 50px;
		margin-left: 0px;
		margin-right: 0px;
	}
`;
const InfoPartenaire = styled.div`
	display: flex;
	flex-direction: column;
	height: 455px;
	background: linear-gradient(180deg, #d8eeff 0%, rgba(216, 238, 255, 0.32) 95.26%);
	border-radius: 10px;
	margin-top: 20px;
	@media ${mobile} {
		height: 100%;
	}
`;
const SAA = styled.div`
	display: flex;
	flex-direction: column;
	width: 50%;
	margin-right: 50px;
	@media ${mobile} {
		width: 100%;
		height: 100%;
		margin-right: 0px;
	}
`;
const IU = styled.div`
	display: flex;
	flex-direction: column;
	width: 50%;
	margin-left: 50px;
	@media ${mobile} {
		width: 100%;
		margin-left: 0px;
		margin-top: 30px;
	}
`;

const SaaLogoContainer = styled.div`
	display: flex;
	margin-bottom: 30px;
	cursor: pointer;
	@media ${mobile} {
		margin-bottom: 40px;
	}
`;
const IuLogoContainer = styled.div`
	display: flex;
	margin-bottom: 30px;
	cursor: pointer;
	@media ${mobile} {
		margin-left: 22px;
		margin-top: 20px;
	}
`;
const OneLineAccessCourseText = styled.div`
	font-size: 30px;
	margin-left: 47px;
	margin-top: 30px;
	color: #000000;
	@media ${mobile} {
		margin-left: 20px;
		font-size: 17px !important;
	}

	@media ${mobile} {
		text-align: center;
		font-size: 19px;
		margin-left: 20px;
		margin-right: 20px;
	}
`;
const ContainerPartener = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-left: 47px;
	margin-right: 47px;
	margin-top: 30px;

	@media ${mobile} {
		flex-direction: column;
		margin-left: 20px;
		margin-right: 20px;
	}
`;
const SaaDesc = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "marginTop",
})<{ marginTop?: number }>`
	text-align: justify;
	text-justify: inter-word;
	font-size: 14px;
	margin-top: ${({ marginTop }) => marginTop && `${marginTop}px`};
`;

const IuDescP1 = styled.div`
	text-align: justify;
	text-justify: inter-word;
	margin-top: 20px;
	font-size: 14px;
`;
const IuDescP2 = styled.div`
	text-align: justify;
	text-justify: inter-word;
	font-size: 14px;
	margin-top: 20px;

	@media ${mobile} {
		margin-bottom: 50px;
	}
`;

const TabView = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>`
	display: flex;
	flex-direction: row;
	cursor: pointer;
	width: 100%;
	${row(0, "space-between", "center")};
	padding: 5px 0px;
	will-change: transform;
	svg  {
		transition: transform ease-in-out 0.2s;
		transform: rotate(-90deg);
	}
	&:hover svg {
		transform: rotate(-90deg) translateY(2px);
	}

	${({ selected, theme }) =>
		selected &&
		css`
			border-bottom: 1px solid ${theme.colors.secondary};
		`}
`;

const Label = styled(Primary)<{ selected?: boolean }>`
	color: ${({ theme, selected }) => (selected ? theme.colors.secondary : theme.colors.textPrimary)};
`;

const BlocApply = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 100px;
	margin-left: 47px;
	margin-right: 47px;
	min-height: 480px !important ;
	max-height: 480px !important ;
	@media ${mobile} {
		flex-direction: column;
		margin-left: 20px;
		margin-right: 0px;
		margin-top: 30px;
		min-height: 520px !important ;
		max-height: 520px !important ;
	}
`;

const LeftBloc = styled.div`
	display: flex;
	flex-direction: column;
	width: 23%;
	margin-right: 12px;
`;
const RightBloc = styled.div`
	display: flex;
	flex-direction: column;
	width: 77%;
	background-color: white;
	border-radius: 10px;
	margin-left: 50px;
	@media ${mobile} {
		width: 100%;
		margin-left: 0px;
		min-height: 400px !important ;
		max-height: 400px !important ;
	}
`;

const ApplyIconBloc = styled.div`
	display: flex;
	margin-left: auto;
	margin-right: 47px;
	margin-top: 40px;
	cursor: pointer;
	margin-bottom: 60px;
	@media ${mobile} {
		width: 93% !important ;
		margin-left: 0px;
		margin-right: 0px;
		margin-bottom: 0px;
		position: fixed;
		bottom: 0;
	}
`;

const ProgramText = styled.div`
	font-size: 22px;
	line-height: 30px;
	margin-top: 12px;
`;

const ViewBrochureBloc = styled.div`
	margin-top: 18px;
`;

const StyledBlocCover = styled.div`
	margin-left: 47px;
	margin-right: 47px;
	margin-top: 30px;
	@media ${mobile} {
		margin-top: 20px;
	}
`;

const StyledCoverAboutOmat = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 13px;
	overflow: hidden;
	> a {
		width: 100%;
		height: 100%;
	}
	margin-left: 47px;
	margin-right: 47px;
	margin-top: 100px;
	@media ${mobile} {
		margin-left: 0px;
		margin-right: 0px;
		margin-top: 30px;
	}
`;
const TalentVideoStoryText = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	font-size: 18px;
	line-height: 129.1%;
	margin-top: 60px;
	margin-left: 20px;
	margin-right: 20px;
	@media ${mobile} {
		margin-top: 20px;
		text-align: center;
	}
`;

const StyledContainerDesc = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	margin-left: 197px;
	margin-right: 197px;
	@media ${mobile} {
		margin-left: 20px;
		margin-right: 20px;
		margin-top: 18px;
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 35px;
	margin-top: 50px;
	@media ${mobile} {
		margin-top: 25px;
		margin-left: 20px;
		margin-right: 20px;
	}
`;

const StyledButtonViewProgram = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 50px;
	@media ${mobile} {
		margin-top: 25px;
		margin-right: 20px;
	}
`;
const DescriptionSecttionP1 = styled.div`
	justify-content: center;
	align-items: center;
	font-size: 14px;
	line-height: 129.1%;
	text-align: center;
	@media ${mobile} {
		text-align: justify;
		text-justify: inter-word;
	}
`;

const DescriptionSectionP2 = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	line-height: 129.1%;
	margin-top: 20px;
	text-align: center;
	@media ${mobile} {
		text-align: justify;
		text-justify: inter-word;
	}
`;

const StyledBackgroundImageCover = styled(BackgroundImage)`
	height: 339px;
	@media ${mobile} {
		height: 235px;
	}
`;
const StyledBackgroundImageLargeCover = styled(BackgroundImage)`
	width: 100%;
	height: 592.2px;
	@media ${mobile} {
		height: 235px;
	}
`;
const StyledBackgroundImageCoverAboutOmat = styled(BackgroundImage)`
	width: 100%;
	height: 177px;
	@media ${mobile} {
		height: 115px;
	}
`;

const ContentCover = styled(RoundedBlock)`
	position: relative;
	flex-direction: column;
	align-items: center;
	border-radius: 13px;
	overflow: hidden;
	margin-top: 12px;

	> a {
		width: 100%;
		height: 100%;
	}

	@media ${mobile} {
		padding-top: 0;
	}
`;

const StyledTabBar = styled.div`
	grid-area: menu;
	position: sticky;
	${gap(20)};
	@media ${mobile} {
		${gap(30)};
		animation: ${fromLeft} 0.2s linear;
		margin-top: 30px;
	}

	border-bottom: solid 1px #6498f9;
`;

const StyledTabBarLabel = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`;

const StyledProgramDesc = styled.div`
	display: flex;
	font-size: 14px;
	line-height: 21px;
	margin-top: 20px;
	text-align: justify;
	text-justify: inter-word;
`;

const StyledBlocProgramDesc = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 47px;
	margin-right: 47px;
	margin-top: 28px;
	@media ${mobile} {
		margin-left: 20px;
		margin-right: 20px;
		margin-top: 14px;
	}
`;

const StyledBlocCounter = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: 47px;
	margin-right: 47px;
	margin-top: 64px;
`;

const StyledCardCounterBourse = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 261px;
	height: 115px;
	background-color: #3db0aa;
`;
const StyledCardNumberOfCountry = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 248px;
	height: 115px;
	background-color: #fbb513;
	margin-left: 20px;
`;
const StyledCardNumberOfCursus = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 275px;
	height: 115px;
	background-color: #bd88c6;
	margin-left: 20px;
`;
const StyledCardNumberOfOnlineCourse = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 368px;
	height: 115px;
	background-color: #ed767e;
	margin-left: 20px;
`;

const StyledNumberCounter = styled.div`
	font-size: 50px;
	color: white;
`;
const StyledLabelText = styled.div`
	font-size: 16px;
	color: white;
`;

const StyledLabel = styled.div`
	font-size: 30px;
	color: black;
	margin-bottom: 0px !important ;
	text-align: center;
	@media ${mobile} {
		font-size: 15px;
	}
`;

const Infos = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	pointer-events: none;
	padding: 50px;
	${gap(10)};
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-end;
	color: ${({ theme }) => theme.colors.white};

	@media ${mobile} {
		padding: 28px;
	}
`;

const InfosBachelor = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	pointer-events: none;
	${gap(10)};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	margin-top: 20px;

	@media ${mobile} {
		padding: 10px;
	}
`;

const BachelorLabel = styled.div`
	font-size: 15px;
	color: black;
	text-align: center;
	margin-bottom: 0px !important;
	color: ${({ theme }) => theme.colors.white};
`;
const ProgramUILabel = styled.div`
	font-size: 12px;
	color: black;
	text-align: center;
	margin-bottom: 0px !important;
	color: ${({ theme }) => theme.colors.white};
`;
const Divider = styled.div`
	width: 2px;
	height: 100%;
	min-height: 314px;
	background-color: ${({ theme }) => theme.colors.white};
`;

const StyledBlocCounterInMobile = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 20px;
	margin-right: 20px;
	margin-top: 30px;
`;
const StyledCardCounterBourseIsMobile = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 115px;
	background-color: #3db0aa;
`;

const StyledCardNumberOfCountryIsMobile = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 115px;
	background-color: #fbb513;
	margin-top: 20px;
`;

const StyledCardNumberOfCursusIsMobile = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 115px;
	background-color: #bd88c6;
	margin-top: 20px;
`;

const StyledCardNumberOfOnlineCourseIsMobile = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 115px;
	background-color: #ed767e;
	margin-top: 20px;
`;
